import type {DocumentManager} from '@wix/document-manager-core'
import type {MasterPageMigrator} from '../dataMigrationRunner'
import * as constants from '../../../../constants/constants'

const {DATA_TYPES} = constants

const SYSTEM_STYLES_TO_FIX = [
    {id: 'tpas0', skin: 'wysiwyg.viewer.skins.TPASectionSkin'},
    {id: 'tpaw0', skin: 'wysiwyg.viewer.skins.TPAWidgetSkin'}
]

const fixSystemStyle = ({dal, pointers}: DocumentManager, styleId: string, skin: string) => {
    const stylePointer = pointers.getPointer(styleId, DATA_TYPES.theme)
    const style = dal.get(stylePointer)
    if (style === undefined || style.skin !== undefined) {
        return
    }

    const styleSkinPointer = pointers.getInnerPointer(stylePointer, 'skin')
    dal.set(styleSkinPointer, skin)
}

const migrateMasterPage = (documentManager: DocumentManager) => {
    for (const {id, skin} of SYSTEM_STYLES_TO_FIX) {
        fixSystemStyle(documentManager, id, skin)
    }
}

const name = 'fixTpas0SystemStyleMissingSkin'
const version = 2

export const fixTpas0SystemStyleMissingSkin: MasterPageMigrator = {
    migrateMasterPage,
    name,
    version
}
